
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/[b_alias]/[bid]",
      function () {
        return require("private-next-pages/b/[b_alias]/[bid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b/[b_alias]/[bid]"])
      });
    }
  